// extracted by mini-css-extract-plugin
export default {"AddProductContainer":"GroceryProducts_AddProductContainer__EoUCI"};